module.exports = __webpack_public_path__ + "static/media/message-promotion-title.43971e64.png";